import WordCloud from "./WordCloud";

/**
 * Alpine.js component for WordCloud
 * @returns {Object} Alpine.js component definition
 */
export default () => ({
	/**
	 * @type {string|null} id - The unique identifier for the word cloud container.
	 */
	id: null,

	/**
	 * @type {WordCloud|null} wordCloud - The WordCloud instance.
	 */
	wordCloud: null,

	animationStarted: false,

	/**
	 * Generates a random string ID of 10 alphabetic characters.
	 * @returns {string} - The generated random ID.
	 */
	generateId: () => {
		const characters =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		let id = "";
		for (let i = 0; i < 10; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			const randomChar = characters.charAt(randomIndex);
			id += randomChar;
		}
		return id;
	},

	/**
	 * Starts the word cloud animation.
	 * @return {void}
	 */
	startAnimation() {
		if (this.animationStarted) return;

		this.wordCloud.start();
		this.animationStarted = true;
	},

	/**
	 * Initializes the WordCloud component.
	 * Alpine.js calls this method when the component is initialized.
	 * @return {void}
	 */
	init() {
		const element = this.$el;
		this.id = this.generateId();
		element.id = this.id;
		this.wordCloud = new WordCloud(element);
	},
});
